import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../animations/Reveal';
import {
    FaShieldAlt,
    FaTruck,
    FaLeaf,
    FaHeart,
    FaStar,
    FaRecycle
} from 'react-icons/fa';
import '../../styles/globals.css';
import '../../styles/cart.css';

const TrustBar = () => {
    const trustPoints = [
        {
            icon: FaShieldAlt,
            title: "Secure Checkout",
            description: "256-bit SSL encryption"
        },
        {
            icon: FaTruck,
            title: "Free Shipping",
            description: "Orders over $100"
        },
        {
            icon: FaLeaf,
            title: "Cruelty Free",
            description: "Leaping Bunny Certified"
        },
        {
            icon: FaHeart,
            title: "30-Day Returns",
            description: "Happiness guaranteed"
        },
        {
            icon: FaStar,
            title: "Premium Quality",
            description: "Dermatologist inspired"
        },
        {
            icon: FaRecycle,
            title: "Sustainable",
            description: "Eco-conscious packaging"
        }
    ];

    return (
        <Reveal>
            <div className="mt-10 mb-10 pt-16 border-t border-nude/50">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                    {trustPoints.map((point, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            whileHover={{ y: -5 }}
                            className="text-center group"
                        >
                            <div className="inline-flex w-12 h-12 rounded-2xl bg-gradient-to-br from-champagne/10 to-sage/10 items-center justify-center mb-3 group-hover:from-champagne/20 group-hover:to-sage/20 transition-all duration-300">
                                <point.icon className="w-5 h-5 text-champagne" />
                            </div>
                            <h4 className="text-sm font-medium text-charcoal mb-1">
                                {point.title}
                            </h4>
                            <p className="text-xs text-charcoal/40">
                                {point.description}
                            </p>
                        </motion.div>
                    ))}
                </div>

            </div>
        </Reveal>
    );
};

export default TrustBar;